import React, { useState, useEffect, useMemo, useRef } from "react";
import { InputText } from "primereact/inputtext";
import Layout from "../../../components/common/nav/initiator/nav.component";
import { Auth, DataStore, Predicates, SortDirection, Storage } from "aws-amplify";
import { ValidateAllRoleExceptAdmin } from "../../../helper/validateRole";
import ReactFullscreen from "react-easyfullscreen";
import { Sidebar } from "primereact/sidebar";
import Editpopup from "../../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from "../../../setup/auth/login.component";
import { Dropdown } from "primereact/dropdown";
import {
  ConvertResponseOfNameCodeForSelect
} from "../../../helper/commonfunctions";
import { Schools, StipendMaster, StipendAssignments, YearMaster, SemisterMaster, Employee, StipendTransactionCycle } from "../../../models";
import moment from "moment";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { toast } from "react-toastify";
import { reactLocalStorage } from "reactjs-localstorage";
import { USER_TYPES, USER_TYPES_NAMES, Request_Stipend_Status, stipend_Type } from "../../../helper/enum";
import { SendNotification } from "../../../helper/mail";
import { InputSwitch } from "primereact/inputswitch";
import SignatureDialog from "../../../components/signature/SignatureDialog";
import { blobToDataURL, dataURLtoBlob } from "../../../components/signature/signatureHelper";
import { Card } from 'primereact/card';
import StipendFormPdf from '../../../components/reportpdftemplate/stipendFormPDF';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { handleNotificationsOnStatusChangeforStipendForm } from "../../../components/actions/notficationActions";

export default function StipendEmployee() {
  const location = useLocation();
  let navigateTo = useNavigate();

  const { id } = useParams();
  const [schoolYear, setSchoolYear] = useState('');
  const [locationSchool, setSchoolLocation] = useState('');
  const [semister, setSemister] = useState('');
  const [departmentId, setDepartmentId] = useState('');
  const [departmentPeopleCount, setDepartmentPeopleCount] = useState('');
  const [assignmentArray, setAssignmentArray] = useState([{
    "name": "", "amount": ""
  }]);
  const approverLevelForReject = [
    { label: 'Initiator', value: 'I' },
    { label: 'Principal', value: 'P' },
    { label: 'HR', value: 'H' },
  ];
  const [approverListForReject, setApproverListForReject] = useState([]);
  const confirmed = stipend_Type;
  const [selectedConfirmation, setSelectedConfirmation] = useState([]);
  const [submittedOn, setSubmittedOn] = useState();
  const [buttonClicked, setButtonClicked] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [employeId, setEmployeId] = useState("");
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleRequestedReportEdit, setVisibleRequestedReportEdit] = useState(false);
  const [rejectVisible, setRejectVisible] = useState(false);
  const [rejectMsgValue, setRejectValueMsg] = useState("");
  const [sendMsg, setSendMsg] = useState(false);
  const [requestApprovalConfirmVisible, setRequestApprovalConfirmVisible] = useState(false);
  const [position, setPosition] = useState("center");
  const [visibleRight, setVisibleRight] = useState(false);
  const [visibleAgreementPopup, setVisibleAgreementPopup] = useState(false);
  const [activate, setActivate] = useState("");
  const [fallBackApprover, setFallBackApprover] = useState();
  const [fallBackApproverLevel, setFallBackApproverLevel] = useState();
  const [signatureDialog, setSignatureDialog] = useState(false);
  const [signaturePath, setSignaturePath] = useState(null);
  const [signatureFileAwsPath, setSignatureFileAwsPath] = useState(null);
  const [addSignature, setAddSignature] = useState(false);

  const cancelButton = (handler) => {
    return (
      <button
        onClick={handler}
        type="button"
        className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
        id="add-family-cancel-btn"
      >
        Cancel
      </button>
    )
  }

  const footerContentForReqApproval = (
    <div className="text-center">
      <button
        className="border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded"
        onClick={() => {
          //BindList();();
          setRequestApprovalConfirmVisible(false);
          setVisibleRequestedReportEdit(false);
          setAddSignature(false);
          if (visibleAgreementPopup) { setVisibleAgreementPopup(false); }
        }}
      >
        Close
      </button>
    </div>
  );

  const footerContentForReqReject = () => (
    <div className="text-center">
      {sendMsg ? (
        <>
          <button
            className="bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded"
            onClick={() => {
              ////BindList();();();
              setRejectVisible(false);
              setVisibleRequestedReportEdit(false);
              setSendMsg(false);
              setAddSignature(false);
              if (visibleAgreementPopup) { setVisibleAgreementPopup(false); }
            }}
          >
            Ok
          </button>
          {cancelButton(() => {
            setFallBackApprover(null);
            setRejectVisible(false);
          })}
        </>
      ) : (
        <>
          <button
            className="bg-[#113699] border border-[##113699] text-white px-8
           py-2 rounded"
            onClick={() => {
              rejectSelectedReport(id);
            }}
          >
            Send
          </button>
          {cancelButton(() => {
            setFallBackApprover(null);
            setRejectVisible(false);
          })}
        </>
      )}
    </div>
  );
  //footer Content code end

  //*state
  const [reportId, setReportId] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");

  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [loggedInUserData, setLoggedInUserData] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, SetUsersList] = useState([]);
  const loggedUserId = reactLocalStorage.get("loggedUserId");

  const [addSignatureHide, setAddSignatureHide] = useState(false);

  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateAllRoleExceptAdmin()) {
        userHasAuthenticated(false);
      }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region
  });


  async function approveEmployeeSignClick() {
    console.log("APPP approveSelectedReport reportId:-", id);
    const stipendMasterReport = await DataStore.query(StipendMaster, id);
    console.log(JSON.stringify(stipendMasterReport) + 'stipendMasterReport')

    const transactionCycleResponse = await DataStore.query(StipendTransactionCycle, (c) => c.and(c => [
      c.report_Id.eq(id),
      c.from_Employee_Id.eq(stipendMasterReport.createdBy),
      c.to_Employee_Id.eq(employeId),
      c.status.eq(Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE)
    ]));

    console.log('transactionCycleResponse' + JSON.stringify(transactionCycleResponse))

    const original = await DataStore.query(StipendTransactionCycle, transactionCycleResponse[0].id);

    console.log('originalLateData' + JSON.stringify(original))

    await DataStore.save(
      StipendTransactionCycle.copyOf(original, (updated) => {
        updated.isApproved = true;
        updated.signature_File_Path = signaturePath;
        updated.submittedDate= moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
      })
    ).then(async (response) => {
      console.log('response' + JSON.stringify(response))
      //after we add another row for save report id for reporting managers approver
      try {
        await DataStore.save(
          new StipendTransactionCycle({
            report_Id: id,
            from_Employee_Id: employeId,
            to_Employee_Id: stipendMasterReport.principalId,
            status: Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL,
            isApproved: false,
            remark: "",
            submittedDate: moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
          })
        ).then(async (response) => {

          await DataStore.save(
            StipendMaster.copyOf(stipendMasterReport, (updated) => {
              updated.statusStipend = Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL;
              updated.date = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            })
          );

          await handleNotificationsOnStatusChangeforStipendForm('PENDING_FOR_APPROVAL_PRINCIPAL', stipendMasterReport.id, "STIPENDS_FORM", stipendMasterReport.principalId, loggedUserId);

        })
        setButtonClicked(true)
        toast.success('Approved.');
      }
      catch (e) {
        console.log(e, 'Error of save')
      }


    })

    //props.onClosePopup();
  }

  async function handleRejectClick() {
    // Perform your desired action here
    setRejectVisible(true)
    setButtonClicked(true);
  };

  async function loadStipend(id) {

    const loggedUserId = reactLocalStorage.get("loggedUserId");
    const original = await DataStore.query(StipendMaster, id);
    const employee = await DataStore.query(Employee, original.employeeId);

    //Authentication for Employee user
    if (loggedUserId !== employee.user_Id) {
      userHasAuthenticated(false);
    }

    if (employee)
      setEmployeeName(employee.employee_name + " (" + employee.employee_code + ")")
      setEmployeId(employee.id)

    let assignments = await DataStore.query(StipendAssignments, (c) => c.stipendMasterId.eq(id));

    var myArray = [];
    if (assignments.length > 0) {
      for (let i = 0; i < assignments.length; i++) {
        myArray.push({ "name": assignments[i].name, "amount": assignments[i].amount })
      }
      setAssignmentArray(myArray)
    }

    const schoolYear = await DataStore.query(YearMaster, original.schoolYearId);
    if (schoolYear)
      setSchoolYear(schoolYear.name)

    const semister = await DataStore.query(SemisterMaster, original.semisterId);
    if (semister)
      setSemister(semister.name)

    const school = await DataStore.query(Schools, original.schoolId);
    if (school)
      setSchoolLocation(school.name)

    if (original.isMiddleStipend === true) {
      setSelectedConfirmation([{ name: 'Middle School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isMiddleStipend' }])
    } else if (original.isElementaryStipend === true) {
      setSelectedConfirmation([{ name: 'Elementary Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isElementaryStipend' }])
    } else if (original.isHighStipend === true) {
      setSelectedConfirmation([{ name: 'High School Extra-Curricular Stipend(01.0-00000.0-11303-10000-1170-0005616)', key: 'isHighStipend' }])
    } else if (original.isDepartmentStipend === true) {
      setSelectedConfirmation([{ name: 'Department Chair Stipend(01.0-00000.0-11303-10000-1170-0005616)(01.0-65000.0-57606-11100-1170-0000600-SPED)', key: 'isDepartmentStipend' }])
    } else if (original.isHeadStipend === true) {
      setSelectedConfirmation([{ name: 'Head Counselor Stipend(01.0-00000.0-00000-31101-1272-0004682)', key: 'isHeadStipend' }])
    }

    setSubmittedOn(moment(original.updatedAt).format("YYYY-MM-DD")) //original.submittedOn

    const StipendTransactionCycleData = await DataStore.query(StipendTransactionCycle, (c) => c.and(c => [
      c.report_Id.eq(id),
      c.to_Employee_Id.eq(employeId),
      c.status.eq(Request_Stipend_Status.PENDING_FOR_APPROVAL_EMPLOYEE),
      c.isApproved.eq(true)
    ]));

    if (StipendTransactionCycleData.length > 0) {
      setAddSignature(StipendTransactionCycleData[0].isApproved)
      setButtonClicked(true)
      // loadSignatureFile(StipendTransactionCycleData[0].signature_File_Path)
    }

  }

  const loadUsers = () => {
    //------------------------------- load users-------------
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        console.log("data is ", data);
        SetUsersList(data.Users);

        var newRes = [];
        let userRole = "",
          userName = "",
          userEmail = "",
          userCode = "",
          signature = "",
          sub = "";

        data.Users.forEach((user, i) => {
          userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
          userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
          userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
          userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
          signature = user.Attributes.find(attr => attr.Name === "custom:userSignature")?.Value;
          sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
          let obj = {
            userId: sub,
            name: userName,
            email: userEmail,
            usercode: userCode,
            role:
              userRole === USER_TYPES.SUPERADMIN
                ? USER_TYPES_NAMES.SA
                : userRole === USER_TYPES.ADMIN
                  ? USER_TYPES_NAMES.A
                  : userRole === USER_TYPES.APPROVER
                    ? USER_TYPES_NAMES.AP
                    : userRole === USER_TYPES.PAYROLL
                      ? USER_TYPES_NAMES.P
                      : USER_TYPES_NAMES.I
          };
          newRes.push(obj);
        });

        //get only those users are without admin
        let usersWithoutAdminAndLoggedUser = [];
        const loggedUserId = reactLocalStorage.get("loggedUserId");

        newRes.map(currentItem => {
          if (currentItem.role !== "Admin" && currentItem.userId !== loggedUserId) {
            usersWithoutAdminAndLoggedUser.push(currentItem);
          }
        });

        // setting logged in user data
        setLoggedInUserData(newRes.filter((user) => user.userId === loggedUserId)?.[0]);

        //set employee list
        let finalEmployeeList = [{ name: "No Approval Needed", code: "no_approval_needed" }];

        usersWithoutAdminAndLoggedUser.map(currentItem => {
          let obj = { name: currentItem.name, code: currentItem.userId };
          finalEmployeeList.push(obj);
        });
        setEmployeeList(finalEmployeeList);

        var approverArrayReject = []; approverArrayReject = ConvertResponseOfNameCodeForSelect(finalEmployeeList); setApproverListForReject(approverArrayReject);

        console.log("approverArrayReject", approverArrayReject)
        console.log("approverLevelForReject", approverLevelForReject)
      }
    });
    //-------------------------------------------------------
  };

  //reject report function
  const rejectSelectedReport = async reportId => {
    if (rejectMsgValue === "") {
      toast.error("Please Add Reason For Rejection");
      return;
    }

    if (!fallBackApprover) {
      toast.error("Please Select A Fall Back Approver");
      return;
    }

    // get specific report id transaction table data and add rejected status in specific entry
    try {

      const originalStipendMaster = await DataStore.query(StipendMaster, id);

      const latestStipendTransactionCycle = await DataStore.query(StipendTransactionCycle, c =>
        c.report_Id.eq(originalStipendMaster.id), { sort: s => s.createdAt(SortDirection.DESCENDING) }
      );

      const original = await DataStore.query(StipendTransactionCycle, latestStipendTransactionCycle[0].id);
      console.log('original-->fallBackApproverLevel' + JSON.stringify(original.status))

      let toEmployeeStatus = '';

      if (fallBackApproverLevel === 'I') {
        // alert(fallBackApproverLevel,'I')
        toEmployeeStatus = Request_Stipend_Status.PENDING
      }
      else if (fallBackApproverLevel === 'P') {
        if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_FINAL_APPROVAL) {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL
        } else if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_EXCECUTIVE_MANAGEMENT) {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL
        }
        else {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_PRINCIPAL
        }

        // alert(fallBackApproverLevel,'P')

      } else if (fallBackApproverLevel === 'H') {

        if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN) {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN
        } else if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN) {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_ASSIGNMENT_COMPLETION_HR_TECHNICIAN
        } else if (latestStipendTransactionCycle[0].status === Request_Stipend_Status.ACKNOWLEDGMENT_HR_TECHNICIAN) {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_ACKNOWLEDGMENT_HR_TECHNICIAN
        } else {
          toEmployeeStatus = Request_Stipend_Status.PENDING_FOR_APPROVAL_HR_TECHNICIAN
        }
      }

      await DataStore.save(
        StipendTransactionCycle.copyOf(original, (updated) => {
          updated.status = Request_Stipend_Status.REJECT;
          updated.remark = rejectMsgValue;
          updated.date = moment().format("YYYY-MM-DD");
        })
      ).then(async (response) => {

        const stipendMasterReport = await DataStore.query(StipendMaster, original.report_Id);

        await DataStore.save(
          StipendMaster.copyOf(stipendMasterReport, (updated) => {
            updated.statusStipend = Request_Stipend_Status.PENDING;
            // updated.remark = rejectMsgValue;
            updated.date = moment().format("YYYY-MM-DD");
          })
        )

        //after we add another row for save report id for reporting managers approver
        const addNewRowForRMReasponse = await DataStore.save(
          new StipendTransactionCycle({
            report_Id: stipendMasterReport.id,
            from_Employee_Id: loggedUserId,
            to_Employee_Id: fallBackApprover,
            status: toEmployeeStatus,
            isApproved: false,
            remark: rejectMsgValue,
            date: moment().format("YYYY-MM-DD")
          })
        );

        await handleNotificationsOnStatusChangeforStipendForm('REJECT', stipendMasterReport.id, "STIPENDS_FORM", fallBackApprover, loggedUserId, rejectMsgValue);

      });
      setRejectValueMsg("");
      setSendMsg(true);
      loadStipend(id)
    } catch (err) {
      console.log("Error in reject specific report function");
    }

  };

  useEffect(() => {
    //BindList();();
    loadStipend(id);
    onLoad();
    console.log(addSignatureHide + 'addSignatureHide')
  }, [users]);

  useEffect(() => {
    // loadUsers();
    if (addSignature) { //&& loggedUserId === employeId
      handleAddSignature();
    }

    console.log('employee' + JSON.stringify(employeeName))
    console.log(signatureFileAwsPath !== null && !addSignature, signatureFileAwsPath, addSignature);
  }, [addSignature, employeeName])


  const uploadSignature = async (signature) => {

    const fileName = 'profile/' + employeId + '/signature.png'; //loggedInUserData.userId

    console.log("fileName", signature);

    const blob = await dataURLtoBlob(signature);

    try {
      toast.loading('Uploading please wait...');
      await Storage.put(fileName, blob, {
        resumable: true,
        completeCallback: (event) => {
          toast.dismiss();
          Auth.currentAuthenticatedUser()
            .then((user) => {
              return Auth.updateUserAttributes(user, {
                'custom:userSignature': fileName,
              });
            }).catch((err) => toast.error(err.message));
        },

        errorCallback: (err) => {
          toast.error(err.message);
        },

      });
      // setSignatureFileAwsPath(signature);
    } catch (error) {
      console.log('Error uploading file: ', error);
    }
    return fileName;
  }

  const handleSignatureSelection = async (image) => {
    setSignatureDialog(false);
    setSignatureFileAwsPath(null);
    const signatureFilePath = await uploadSignature(image);
    if (signatureFilePath.trim() !== '') {
      setSignaturePath(signatureFilePath);
      // loadSignatureFile(signatureFilePath);
      setSignatureFileAwsPath(image);
    } else {
      signatureFilePath(null);
    }
  }

  const loadSignatureFile = async (filePath) => {
    let file = null;
    await Storage.get(filePath)
      .then(result => {
        console.log(result);
        file = result;
      });

    console.log("signature", file);

    if (file) {
      setSignatureFileAwsPath(file);
    }
  }


  const handleAddSignature = async () => {
    const cognito = new AWS.CognitoIdentityServiceProvider();

    var params = {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };

    params['Filter'] = "sub ^=\"" + loggedUserId+ "\"";
    await cognito.listUsers(params, (err, data) => {
      if (data) {
        let signature = data.Users[0].Attributes.find(attr => attr.Name === "custom:userSignature")?.Value;
        if (signature != null && signature.trim() !== '') {
          setSignaturePath(signature);
          loadSignatureFile(signature)
        } else {
          setSignatureDialog(true);
        }
      }
    });
  }

  const [hideLeftPanel, setHideLeftPanel] = useState(false);
  const [hideRightPanel, setHideRightPanel] = useState(false);

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    const shouldHideLeftPanel = screenWidth <= 1280; // Adjust the breakpoint as per your needs
    const shouldHideRightPanel = screenWidth <= 1280; // Adjust the breakpoint as per your needs

    setHideLeftPanel(shouldHideLeftPanel);
    setHideRightPanel(shouldHideRightPanel);
  };

  useEffect(() => {
    // Call handleResize on initial mount
    handleResize();

    // Add event listener for window resizing
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener when the component is unmounted
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isAuthenticated ? (
    <>
      <ReactFullscreen>
        {({ onToggle }) => (
          <Layout pageTitle="Report" activeMenu="Initiator">
            <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">

              <div className="grid grid-cols-1 md:grid-cols-6 gap-4 pb-5">
                <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                  <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                      <div className='col-span-8'>
                        <div className='border'>
                          <div className="lg:flex lg:items-center py-5 lg:justify-between">
                            <div className="min-w-0 flex-1">
                              <h6 className="px-5 flex items-center text-2xl font-semibold leading-7 text-gray-600 sm:truncate  sm:tracking-tight">
                                Stipend Assignment
                              </h6>
                              <p className="px-5">Acknowledgement</p>
                              <h6 className='flex items-center mt-4'>
                                <DocumentTextIcon className="h-4 w-4 me-1 px-2" aria-hidden="true" /> Stipend Assignment.pdf</h6>

                              <div className='bg-[#eeeff0] py-4 px-6 mt-2 employee_handbookss'>
                                <StipendFormPdf
                                  data={{
                                    'schoolName': locationSchool,
                                    'schoolYear': schoolYear,
                                    'schoolSemister': semister,
                                    'employeeName': employeeId.name,
                                    'departmentTypeName': departmentId.name,
                                    'departmentCount': departmentPeopleCount,
                                    'assignmentArray': assignmentArray,
                                    'stipendTypes': confirmed,
                                    'selectedConfirmation': selectedConfirmation,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-2 lg:col-span-4 bg-[#F5F6F7] h-auto bg-white">
                        <div className='px-4 p-5 right_box border'>
                          <div className="mb-1 mt-2">
                            <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Employee Name</label>
                            <div className="mt-2">
                              <InputText value={employeeName ? employeeName : ''} id="username" placeholder="" className="w-full placeholder:text-[#667085] bg-[#D0D5DD] h-10" aria-describedby="" /></div>
                          </div>
                          <div className="mb-1 mt-2">
                            <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">Date</label>
                            <div className="mt-2">
                              <InputText value={submittedOn ? moment(submittedOn).format("MM/DD/YYYY") : ''} id="username" placeholder="" className="w-full placeholder:text-[#667085] h-10" aria-describedby="" /></div>
                          </div>

                          <div className="mb-1 mt-2 pb-5">
                            <div className="pl-5 pt-5 text-[#344054] font-medium text-[20px] flex">
                              <InputSwitch checked={addSignature} onChange={(e) => setAddSignature(e.value)} />
                              <label style={{ marginLeft: "2%" }}>Add Signature <span class="text-[red] pl-0.2">*</span></label>
                            </div>

                            {(addSignature && signatureFileAwsPath !== null) ?
                              <div className="py-3 px-5 rounded-[8px] mt-3">
                                <Card>
                                  <img className={"w-[20%] h-[15%]"}
                                    src={signatureFileAwsPath}
                                  />
                                </Card>
                              </div> : null}
                          </div>

                          <div className="grow flex justify-end gap-3 mb-3 mt-20 px-4">
                            {/* <Link to=""
                             onClosePopup={() => {
                              setAddSignature(false);
                              if (searchParams.get("stipend_request")) {
                                navigateTo("/stipend_request");
                              }
                            }}
                             className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none leading-6  justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"> <i className="gusd-close mr-1" style={{ fontSize: '0.7rem' }}></i>Cancel</Link> */}

                            <Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                              onClick={handleRejectClick}
                            ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link>

                            <button onClick={approveEmployeeSignClick} disabled={buttonClicked || !addSignature || signatureFileAwsPath === null} className={`${(buttonClicked || !addSignature || signatureFileAwsPath === null) ? 'gray ' : 'blue '} custmBtn radius8 text-center`}>Confirm</button>
                          </div>
                        </div>


                      </div>
                    </div>



                    <Dialog
                      header=""
                      visible={requestApprovalConfirmVisible}
                      style={{ width: "30vw" }}
                      closable={false}
                      onHide={() => {
                        setRequestApprovalConfirmVisible(false);
                        setVisibleEdit(false);
                      }}
                      footer={footerContentForReqApproval}
                    >
                      <p className="m-0 text-[#0487C8] text-center">
                        <i className="mr-2 pi pi-check-circle"></i>
                        <span className="font-medium text-[18px]">This report is Approved</span>
                      </p>
                    </Dialog>

                    {/* Reject dialog */}
                    <Dialog
                      header="Reject Report"
                      visible={rejectVisible}
                      style={{ width: "30vw" }}
                      //                      closable={false}
                      onHide={() => {
                        setRejectVisible(false);
                        // setVisibleEdit(false);
                      }}
                      footer={footerContentForReqReject}
                    >
                      <div className="m-0">
                        {sendMsg && <div className="font-medium text-[18px] text-[#249144] mb-6">Message Sent Successfully</div>}

                        <div className="font-medium text-[18px] mb-3">Select an approver level</div>
                        <Dropdown
                          value={fallBackApproverLevel}
                          options={approverLevelForReject}
                          onChange={(e) => setFallBackApproverLevel(e.value)}
                          optionLabel="label"
                          placeholder="Select"
                          className="p-column-filter custDropdown w-full mb-6"
                        />

                        <div className="font-medium text-[18px] mb-3">Select an approver</div>

                        <Dropdown
                          value={fallBackApprover}
                          options={approverListForReject}
                          onChange={(e) => setFallBackApprover(e.value)}
                          optionLabel="label"
                          placeholder="Select"
                          className="p-column-filter custDropdown w-full mb-6"
                        />
                        <div className="font-medium text-[18px] mb-3">Enter the Reason for Rejection<span className="text-[red] pl-0.2">*</span></div>

                        <InputText
                          value={rejectMsgValue}
                          placeholder="Enter the Reason for Rejection"
                          onChange={e => setRejectValueMsg(e.target.value)}
                          className="w-full"
                        />
                      </div>
                    </Dialog>
                    {/* edit popup end */}

                    {/*  Signature dialog*/}

                    <SignatureDialog isVisible={signatureDialog}
                      onClickHandler={(image) => handleSignatureSelection(image)}
                      onCloseHandler={() => {
                        setSignatureDialog(false);
                        setAddSignature(false);
                      }}
                      username={employeeName} 
                      // username={loggedInUserData.name}
                    />

                  </div>

                  <Sidebar
                    visible={visibleRight}
                    position="right"
                    onHide={() => setVisibleRight(false)}
                    style={{ width: "35vw" }}
                    className="customesidebar1 responsivepoup"
                  >
                    <Editpopup
                      popupstate={() => setVisibleRight(false)}
                      fromDate={fromDate}
                      toDate={toDate}
                      schoolName={schoolName}
                      reportEmployeeList={reportEmployeeList}
                      status={status}
                      reportId={reportId}
                      // //BindList();={() => loadAbsenceReport()}
                      type={"Initior"}
                    />
                  </Sidebar>
                </div>
              </div>
            </div>

          </Layout>
        )}
      </ReactFullscreen>
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}
